import React from "react"
import SbEditable from "storyblok-react"

import Form from "./Form"
import { blokType } from "../../../types"

interface IEventFormWrapperBlok {
  form: string
  campaign_id_label: string
  campaign_id: Array<{ label: string; value: string }>
  multi_campaign: boolean
}

interface IEventFormWrapper {
  isDark?: boolean
  blok: IEventFormWrapperBlok & blokType
}

export const StoryblokEventFormWrapper: React.FC<IEventFormWrapper> = ({
  isDark = false,
  blok,
}) => {
  
  return (
    <SbEditable content={blok}>
      <div>
        {blok.form && (
          <Form
            multi_campaign={blok.multi_campaign}
            isDark={isDark}
            formUuid={blok.form}
            campaign_id={blok.campaign_id}
            campaign_id_label={blok.campaign_id_label}
          />
        )}
      </div>
    </SbEditable>
  )
}
